import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled, { keyframes } from 'styled-components';
import { BOX_SHADOW_3, HOVER, WHITE } from '../../theme';

const FadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const StyledChatListContainer = styled.div`
  display: inline-flex;
  flex-direction: column;
  width: max-content;
  background: ${WHITE};
  box-shadow: ${BOX_SHADOW_3};
  border-radius: 8px;

  width: 320px;
  max-height: calc(100vh - 140px);

  position: fixed;
  bottom: 80px;
  right: 24px;
  z-index: 2;

  animation: ${FadeIn} 0.2s ease-in-out;
`;

export const StyledHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  padding-bottom: 0;
`;

export const StyledChatList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 16px;
  position: relative;

  padding: 16px;
  margin: 0;

  overflow-y: auto;
`;

export const StyledChatListItem = styled.li`
  display: flex;
  align-items: center;
  gap: 16px;

  position: relative;

  cursor: pointer;
  padding: 4px;
  border-radius: 8px;

  max-width: 100%;

  &:hover {
    background: ${HOVER};
  }
`;

export const StyledChatlistUnreadIndicator = styled(FontAwesomeIcon)`
  position: absolute;

  right: 0;
  top: 50%;
  transform: translateY(-50%);
`;

export const StyledEmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px;
`;
